import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants/index";
import { GetServiceCaller } from "../../../../services/serviceCaller";
import { toast } from "react-toastify";
import ApproveWfhModal from "./ApproveWfhModal";
import RequestCategoryToggle from "../../../../components/RequestCategoryToggle";
import moment from "moment";

const ApproveWfh = ({ activeTab, setActiveTab }) => {
  const [wfhRequests, setWfhRequests] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, setApiStatus] = useState(undefined);
  const [showModal, setShowModal] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const columns = {
    employee_name: { text: "Employee", visible: true },
    applied_date_display: { text: "Applied Date", align: "center", visible: true },
    dates_display: { text: "Dates", align: "center", visible: true },
    request_type: { text: "Type", visible: true },
    reason: { text: "Purpose", visible: true },
    status_name: { text: "Status", align: "center", visible: true },
  };

  const defaultColumns = {
    employee_name: true,
    applied_date_display: true,
    dates_display: true,
    request_type: true,
    reason: true,
    status_name: true,
  };

  useEffect(() => {
    fetchWfhRequests();
  }, []);

  const fetchWfhRequests = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}manager/work-requests`);
      setApiStatus(response?.status);
      if (response.status === 200) {
        const rawData = response.data?.data || [];
        const processedData = rawData.map(req => {
          let datesComponent;
          if (!req.grouped_requests || req.grouped_requests.length === 0) {
            datesComponent = <span className="badge rounded-pill bg-light text-dark border mx-1">{moment(req.date || req.from_date).format('DD-MMM-YYYY')}</span>;
          } else {
            datesComponent = (
              <div className="d-flex flex-wrap justify-content-center">
                {req.grouped_requests.map((r, index) => (
                  <span key={index} className="badge rounded-pill bg-light text-dark border mx-1 mb-1">
                    {moment(r.date || r.from_date).format('DD-MMM-YYYY')}
                  </span>
                ))}
              </div>
            );
          }
          
          const createdAtDate = (req.grouped_requests && req.grouped_requests.length > 0) 
                ? req.grouped_requests[0].created_at 
                : req.created_at;

          return {
            ...req,
            applied_date_display: createdAtDate ? moment(createdAtDate).format("DD-MMM-YYYY") : "N/A",
            dates_display: datesComponent
          };
        });
        setWfhRequests(processedData);
      } else {
        console.error("Failed to fetch WFH requests", response.status);
      }
    } catch (error) {
      console.error("Error fetching WFH requests:", error);
    }
  };

  const handleActionClick = (row) => {
    setSelectedGroup(row.grouped_requests || [row]);
    setShowModal(true);
  };

  return (
    <>
      <div className="container-fluid" id="skill-table-area">
        <RequestCategoryToggle activeTab={activeTab} setActiveTab={setActiveTab} />
        <div className="row">
          <Dynamic_PR_table
            data={wfhRequests}
            columns={columns}
            defaultColumns={defaultColumns}
            itemsPerPage={10}
            searchTerm={searchTerm}
            isApiStatus={apiStatus}
            isRequiredStatus={true}
            setSearchTerm={setSearchTerm}
            showIcon1={true}
            isSorting={true}
            isActionRequired={true}
            handleIcon1={handleActionClick}
            add
            more
            function
            icons={{
              Icon1: <i className="fa fa-check"></i>,
              Icon1Text: "Approve/Reject Request",
            }}
          />
        </div>
      </div>

      <ApproveWfhModal 
        show={showModal} 
        onHide={() => setShowModal(false)}
        groupedRequests={selectedGroup}
        onSuccess={() => {
          fetchWfhRequests();
        }}
      />
    </>
  );
};

export default ApproveWfh;
